import { Flex, TextField, Popover, Button, IconButton } from '@radix-ui/themes';
import React from 'react';
import DatePicker, { DatePickerProps } from 'react-datepicker';
import './date-picker.scss';
import { parse, format } from 'date-fns';
import { DateUtilsService } from 'shared/utils/date-utils.service';
import { ClearIcon } from 'shared/icons';
import { cx } from 'class-variance-authority';

export const AppDatePicker = ({
   inputProps,
   onSelect,
   inputDateFormat = 'dd-MM-yyyy',
   outputDateFormat = 'dd-MM-yyyy',
   onClear,
}: Pick<DatePickerProps, 'maxDate' | 'maxDate'> & {
   onSelect?: (dateString: string) => void;
   onClear?: () => void;
   inputProps: TextField.RootProps;
   inputDateFormat?: string;
   outputDateFormat?: string;
}) => {
   const [showDatePicker, setShowDatePicker] = React.useState(false);

   let selectingDate;
   if (inputProps.value && typeof inputProps.value === 'string') {
      if (DateUtilsService.isValidDate(inputProps.value.trim())) {
         selectingDate = parse(inputProps.value, inputDateFormat, new Date());
      }
   } else {
      selectingDate = undefined;
   }

   return (
      <Flex className='app-date-picker'>
         <Popover.Root open={showDatePicker} onOpenChange={setShowDatePicker}>
            <Popover.Trigger className='app-date-picker__popover-trigger'>
               <Button className="date-picker__trigger" color="blue" highContrast>
                  <TextField.Root
                     {...inputProps}
                     color="blue"
                     pattern="dd.MM.yyyy"
                     className={cx(
                        'date-picker__input',
                        inputProps.value ? 'date-picker__input--with-value' : ''
                     )}
                  >
                     {inputProps.value && (
                        <TextField.Slot side="right">
                           <IconButton
                              className="clear-trigger"
                              variant="ghost"
                              size="2"
                              highContrast
                              onClick={(e) => {
                                 e.stopPropagation();
                                 onClear?.();
                              }}
                           >
                              <ClearIcon width={18} height={18} />
                           </IconButton>
                        </TextField.Slot>
                     )}
                  </TextField.Root>
               </Button>
            </Popover.Trigger>
            <Popover.Content
               side="bottom"
               align="start"
               onOpenAutoFocus={(e) => e.preventDefault()}
            >
               {
                  <DatePicker
                     selected={selectingDate}
                     showPopperArrow={false}
                     onChange={(date) => {
                        let val: Date | null | string = date;
                        if (date) {
                           val = format(date, outputDateFormat);
                           onSelect?.(val);
                        }
                        setShowDatePicker(false);
                     }}
                     popperPlacement="bottom-start"
                     withPortal={false}
                     strictParsing
                     inline
                  />
               }
            </Popover.Content>
         </Popover.Root>
      </Flex>
   );
};
